/**
 * @generated SignedSource<<192a9501fd19331053e02f90641a24ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProfileHeaderQuery$variables = {
  internalId?: string | null;
  username?: string | null;
};
export type ProfileHeaderQuery$data = {
  readonly unified: {
    readonly unifiedProfile: {
      readonly aaid?: string | null;
      readonly company?: string | null;
      readonly extensions?: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly identifier?: string | null;
      readonly isProfileOwnerConsented?: boolean | null;
      readonly location?: string | null;
      readonly message?: string | null;
      readonly role?: string | null;
      readonly username?: string | null;
    } | null;
  } | null;
};
export type ProfileHeaderQuery = {
  response: ProfileHeaderQuery$data;
  variables: ProfileHeaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "internalId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v2 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "internalId"
  },
  {
    "kind": "Variable",
    "name": "unifiedProfileUsername",
    "variableName": "username"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedQueryErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "company",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aaid",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProfileOwnerConsented",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProfileHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0dbebd2eccbc970c64b2d1a265d2e13a",
    "id": null,
    "metadata": {},
    "name": "ProfileHeaderQuery",
    "operationKind": "query",
    "text": "query ProfileHeaderQuery(\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n      ... on UnifiedProfile {\n        role\n        username\n        location\n        company\n        aaid\n        isProfileOwnerConsented\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5731eb3bb0340efb3bb1afba7d93b69c";

export default node;
